// Self-hosted fonts (privacy: no runtime CDN, consistent with the app) and the
// landing styles. The landing is intentionally light on JS — just fonts, the
// stylesheet, and the footer year.
import '@fontsource/space-grotesk/latin-400.css';
import '@fontsource/space-grotesk/latin-600.css';
import '@fontsource/space-grotesk/latin-700.css';
import '@fontsource/ibm-plex-sans/latin-400.css';
import '@fontsource/ibm-plex-mono/latin-400.css';
import './landing.css';

const yearEl = document.getElementById('yr');
if (yearEl) yearEl.textContent = String(new Date().getFullYear());
